import { useEffect, useState } from 'react';

export default function Gallery() {
  const [images, setImages] = useState<any[]>([]);
  const [selectedImg, setSelectedImg] = useState<string | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let isMounted = true;
    fetch(`${process.env.REACT_APP_API_URL}/gallery`)
      .then(res => res.ok ? res.json() : [])
      .then(data => {
        if (isMounted) setImages(data);
      })
      .catch(err => console.error("Помилка завантаження галереї:", err));
    return () => { isMounted = false; };
  }, []);

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % images.length);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);

  const rows = [
    images.slice(0, 5),
    images.slice(5, 11),
    images.slice(11, 16),
    images.slice(16, 22),
  ];

  return (
    <div style={containerStyle}>
      {/* ДЕСТОПНА ВЕРСІЯ */}
      <div className="honeycomb-wrapper desktop-only">
        {rows.map((rowImages, rowIndex) => (
          <div key={rowIndex} className={`hex-row row-${rowIndex + 1}`}>
            {rowImages.map((img, i) => (
              <div 
                key={img.id || `${rowIndex}-${i}`} 
                className="hexagon"
                style={{ animationDelay: `${(rowIndex * 0.1) + (i * 0.05)}s` }}
                onClick={() => setSelectedImg(img.image_url)}
              >
                <div className="hex-inner">
                  <img 
                    src={img.image_url} 
                    alt="Clinic" 
                    loading="lazy" 
                  />
                  <div className="hex-overlay">
                    <div className="plus-icon">+</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* МОБІЛЬНА ВЕРСІЯ */}
      {images.length > 0 && (
        <div className="mobile-slider-container">
          <div className="slider-wrapper">
            <button className="nav-btn" onClick={prevSlide} aria-label="Previous">&#10094;</button>
            
            <div className="hexagon-main" onClick={() => setSelectedImg(images[currentIndex].image_url)}>
               <div className="hex-inner">
                  <img 
                    key={currentIndex}
                    src={images[currentIndex].image_url} 
                    alt="Clinic mobile" 
                    className="fade-in"
                  />
               </div>
            </div>

            <button className="nav-btn" onClick={nextSlide} aria-label="Next">&#10095;</button>
          </div>
          <div className="counter">{currentIndex + 1} / {images.length}</div>
        </div>
      )}

      {/* МОДАЛЬНЕ ВІКНО */}
      {selectedImg && (
        <div className="modal" onClick={() => setSelectedImg(null)}>
          <button className="close-modal-btn" onClick={() => setSelectedImg(null)}>
            <span></span>
            <span></span>
          </button>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImg} alt="Full size" />
          </div>
        </div>
      )}

      <style>{`
        :root {
          --hex-w: 180px;
          --hex-h: calc(var(--hex-w) * 1.1547);
          --gap: 12px; 
          --overlap: calc(var(--hex-w) * 0.2885); 
          --mint: #1abc9c;
        }

        /* Геометрія гексагона */
        .hexagon, .hexagon-main {
          width: var(--hex-w);
          height: var(--hex-h);
          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
          background: var(--mint);
          cursor: pointer;
          position: relative;
          transition: transform 0.3s ease;
          overflow: hidden; /* Важливо для обрізки внутрішнього фото */
        }

        .hex-inner {
          position: absolute;
          top: 2px; left: 2px;
          width: calc(100% - 4px);
          height: calc(100% - 4px);
          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        /* ВИРІШЕННЯ ПРОБЛЕМИ ПОРОЖНЕЧІ:
           Картинка трохи більша за контейнер, щоб зайти під рамку */
        .hex-inner img {
          position: absolute;
          width: 105%; 
          height: 105%;
          object-fit: cover;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: block;
          will-change: transform;
        }

        .desktop-only { display: flex; flex-direction: column; align-items: center; padding: 40px 0; }
        .hex-row { display: flex; margin-top: calc(var(--overlap) * -1 + var(--gap)); }
        
        .desktop-only .hexagon { margin: 0 calc(var(--gap) / 2); opacity: 0; animation: fadeInUp 0.5s forwards; }
        @keyframes fadeInUp { to { opacity: 1; transform: translateY(0); } }

        /* Мобільна адаптація */
        .mobile-slider-container {
          display: none;
          flex-direction: column;
          align-items: center;
          width: 100%;
          padding: 40px 0;
        }

        .slider-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          width: 100%;
          padding: 0 10px;
        }

        .nav-btn {
          background: var(--mint);
          border: none;
          color: white;
          width: 46px; height: 46px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 20px;
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 4px 12px rgba(26, 188, 156, 0.3);
          flex-shrink: 0;
        }

        .counter { margin-top: 20px; color: var(--mint); font-weight: bold; }

        @media (max-width: 1100px) { :root { --hex-w: 145px; } }
        @media (max-width: 900px) {
          .desktop-only { display: none; }
          .mobile-slider-container { display: flex; }
          :root { --hex-w: 260px; }
        }
        @media (max-width: 480px) {
          :root { --hex-w: 64vw; }
          .slider-wrapper { gap: 10px; }
          .nav-btn { width: 40px; height: 40px; }
        }

        /* Гарний хрестик для модалки */
        .modal {
          position: fixed; inset: 0; background: rgba(0,0,0,0.95);
          display: flex; justify-content: center; align-items: center;
          z-index: 9999; backdrop-filter: blur(5px);
        }
        .modal-content img { max-width: 90vw; max-height: 80vh; border-radius: 4px; }

        .close-modal-btn {
          position: absolute; top: 30px; right: 30px;
          width: 44px; height: 44px; background: rgba(255,255,255,0.1);
          border: none; border-radius: 50%; cursor: pointer;
        }
        .close-modal-btn span {
          position: absolute; top: 21px; left: 10px;
          width: 24px; height: 2px; background: white;
        }
        .close-modal-btn span:first-child { transform: rotate(45deg); }
        .close-modal-btn span:last-child { transform: rotate(-45deg); }
        .close-modal-btn:hover { background: var(--mint); }

        .fade-in { animation: fadeIn 0.3s ease; }
        @keyframes fadeIn { from { opacity: 0.5; } to { opacity: 1; } }
      `}</style>
    </div>
  );
}

const containerStyle = {
  width: '100%',
  overflow: 'hidden'
};